import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.confirmIdeal.steps.confirmed.title',
    defaultMessage: 'Confirmation received',
    description: 'title of the confirmed step of the confirm ideal page',
  },
  description: {
    id: 'pages.confirmIdeal.steps.confirmed.description',
    defaultMessage: 'Thank you for confirming the bank account mentioned below.',
    description: 'description of the confirmed step of the confirm ideal page',
  },
  fields: {
    bank: {
      id: 'properties.bank',
      defaultMessage: 'Bank',
      description: 'label of the bank field',
    },
    accountNumber: {
      id: 'properties.accountNumber',
      defaultMessage: 'Account number',
      description: 'label of the account number field',
    },
  },
  actions: {
    continue: {
      id: 'actions.continue',
      defaultMessage: 'Continue',
      description: 'label of the continue button',
    },
  },
};

export default defineMessages(translations);
